/**
 * ApolloRims Vehicle Selector
 * Logic for 4-step vehicle configuration wizard
 */

/**
 * Apollo Rims - Spécialiste BMW F30 / F80 / G20 / G80
 * Données véhicules restreintes à la niche
 */
const vehicleData = {
    "BMW": {
        "Série 3 F30 (2012-2018)": {
            type: "sport",
            years: [2012, 2018],
            pcd: "5x120",
            generation: "F30",
            style: "Street",
            offset: { front: "ET30-35", rear: "ET30-40" },
            sizes: ["18x8", "18x8.5", "19x8.5", "19x9"]
        },
        "M3 F80 (2014-2018)": {
            type: "sport",
            years: [2014, 2018],
            pcd: "5x120",
            generation: "F80",
            style: "Performance",
            offset: { front: "ET22-27", rear: "ET35-40" },
            sizes: ["19x9", "19x10", "20x9", "20x10.5"]
        },
        "Série 3 G20 (2019+)": {
            type: "sport",
            years: [2019, 2026],
            pcd: "5x112",
            generation: "G20",
            style: "Street",
            offset: { front: "ET26-32", rear: "ET38-44" },
            sizes: ["18x8", "18x8.5", "19x8.5", "19x9"]
        },
        "M3 G80 (2021+)": {
            type: "sport",
            years: [2021, 2026],
            pcd: "5x112",
            generation: "G80",
            style: "Performance",
            offset: { front: "ET22-28", rear: "ET32-38" },
            sizes: ["19x9.5", "19x10.5", "20x10", "20x11"]
        }
    }
};

const wheelRules = {
    "sport": [
        // Gamme STREET OEM+ - 2 690€
        {
            size: "18x8.5J",
            weight: "9.2",
            price: 2690,
            tier: "street",
            name: "Street OEM+",
            description: "Upgrade OEM discret",
            pcd: ["5x112", "5x120"],
            finishes: ["Noir Satiné", "Argent Hyper", "Gunmetal"]
        },
        // Gamme SPORT PERFORMANCE - 3 190€
        {
            size: "19x9J / 19x10J",
            weight: "10.5",
            price: 3190,
            tier: "sport",
            name: "Sport Performance",
            description: "Concavité agressive",
            pcd: ["5x112", "5x120"],
            finishes: ["Bronze Satiné", "Noir Mat", "Carbone Look"]
        },
        // Gamme TRACK ULTRA - 3 690€
        {
            size: "19x10J / 20x10.5J",
            weight: "9.8",
            price: 3690,
            tier: "track",
            name: "Track Ultra",
            description: "Circuit-ready, flow-formed",
            pcd: ["5x112", "5x120"],
            finishes: ["Noir Brillant", "Or Satiné", "Custom"]
        }
    ]
};

class VehicleSelector {
    constructor() {
        this.modal = document.getElementById('vehicle-selector-modal');
        this.steps = {
            1: document.getElementById('step-brand'),
            2: document.getElementById('step-model'),
            3: document.getElementById('step-year'),
            4: document.getElementById('step-results')
        };
        this.currentStep = 1;
        this.selection = {
            brand: null,
            model: null,
            year: null,
            model: null
        };

        this.init();
    }

    init() {
        if (this.modal) {
            this.initModal();
        }

        // Check if we are on the results page
        const resultsContainer = document.getElementById('vehicle-results-container');
        if (resultsContainer) {
            this.initResultsPage();
        }
    }

    initModal() {
        // Modal mode: Bind triggers
        document.querySelectorAll('[href^="/collections/shop-by-vehicle"]').forEach(link => {
            link.addEventListener('click', (e) => {
                e.preventDefault();

                // Check for brand param
                const url = new URL(link.href);
                const brand = url.searchParams.get('brand');

                this.open();

                if (brand && vehicleData[brand]) {
                    this.selectBrand(brand);
                }
            });
        });

        // Close button
        this.modal.querySelector('.vehicle-modal-close').addEventListener('click', () => this.close());

        // Back buttons
        this.modal.querySelectorAll('.modal-back-btn').forEach(btn => {
            btn.addEventListener('click', () => this.prevStep());
        });

        // Populate Brands
        this.renderBrands();
    }

    initResultsPage() {
        const urlParams = new URLSearchParams(window.location.search);
        const brand = urlParams.get('brand');
        const model = urlParams.get('model');
        const type = urlParams.get('type');

        if (type === 'carbon') {
            this.renderResults(true, 'carbon');
        } else if (brand && model && vehicleData[brand] && vehicleData[brand][model]) {
            this.selection.brand = brand;
            this.selection.model = model;
            // No year selection anymore
            this.renderResults(true); // true = render in static container
        } else {
            document.getElementById('results-list').innerHTML = '<div class="no-results">Veuillez sélectionner un véhicule valide.</div>';
        }
    }

    open() {
        this.modal.classList.add('active');
        document.body.style.overflow = 'hidden';
        this.goToStep(1);
    }

    close() {
        this.modal.classList.remove('active');
        document.body.style.overflow = '';
    }

    goToStep(step) {
        // Hide all steps
        Object.values(this.steps).forEach(el => {
            if (el) el.classList.remove('active', 'prev');
        });

        // Show current step
        if (this.steps[step]) this.steps[step].classList.add('active');

        // Mark previous steps
        for (let i = 1; i < step; i++) {
            if (this.steps[i]) this.steps[i].classList.add('prev');
        }

        this.currentStep = step;
        this.updateHeader(step);
    }

    prevStep() {
        if (this.currentStep > 1) {
            this.goToStep(this.currentStep - 1);
        }
    }

    updateHeader(step) {
        const titles = {
            1: "Sélectionnez votre Marque",
            2: "Sélectionnez votre Modèle"
        };
        const headerTitle = this.modal.querySelector('.vehicle-modal-header h2');
        if (headerTitle) headerTitle.textContent = titles[step];

        // Show/Hide back button
        const backBtn = this.modal.querySelector('.modal-back-btn');
        if (backBtn) {
            if (step > 1) {
                backBtn.style.display = 'flex';
            } else {
                backBtn.style.display = 'none';
            }
        }
    }

    renderBrands() {
        const container = document.getElementById('brand-list');
        if (!container) return;
        container.innerHTML = '';

        Object.keys(vehicleData).sort().forEach(brand => {
            const btn = document.createElement('div');
            btn.className = 'selection-btn';
            btn.innerHTML = `<span>${brand}</span>`;
            btn.onclick = () => this.selectBrand(brand);
            container.appendChild(btn);
        });
    }

    selectBrand(brand) {
        this.selection.brand = brand;
        this.renderModels(brand);
        this.goToStep(2);
    }

    renderModels(brand) {
        const container = document.getElementById('model-list');
        if (!container) return;
        container.innerHTML = '';

        const models = vehicleData[brand];
        Object.keys(models).sort().forEach(model => {
            const btn = document.createElement('div');
            btn.className = 'selection-btn';
            btn.innerHTML = `<span>${model}</span>`;
            btn.onclick = () => this.selectModel(model);
            container.appendChild(btn);
        });
    }

    selectModel(model) {
        this.selection.model = model;
        // REDIRECT TO RESULTS PAGE (Zero Config via Search View)
        const brand = this.selection.brand;
        window.location.href = `/search?view=vehicle&brand=${encodeURIComponent(brand)}&model=${encodeURIComponent(model)}`;
    }

    renderResults(isStatic = false, forceType = null) {
        const containerId = 'results-list'; // Same ID, different page context
        const container = document.getElementById(containerId);
        if (!container) return;

        container.innerHTML = '<div class="loading-spinner"><div class="spinner"></div></div>';

        // Simulate network delay
        setTimeout(() => {
            container.innerHTML = '';
            let wheels = [];
            let style = null;
            let type = null;
            let pcd = null;

            if (forceType === 'carbon') {
                wheels = wheelRules['carbon'] || [];
                style = 'Carbon';
                // Update title if possible
                const title = document.getElementById('results-title');
                if (title) title.textContent = "Jantes Fibre de Carbone";
            } else {
                const modelData = vehicleData[this.selection.brand][this.selection.model];
                type = modelData.type; // city, suv, sport
                pcd = modelData.pcd;
                style = modelData.style;

                // Get standard wheels for the type
                wheels = [...wheelRules[type]];

                // Add Carbon Fiber wheels for EVERYONE (if PCD matches)
                if (wheelRules["carbon"]) {
                    wheels = wheels.concat(wheelRules["carbon"]);
                }

                // Filter by PCD if available
                if (pcd) {
                    wheels = wheels.filter(w => w.pcd && w.pcd.includes(pcd));
                }
            }

            if (wheels.length === 0) {
                container.innerHTML = '<div class="no-results">Aucun résultat exact trouvé. Contactez-nous pour du sur-mesure.</div>';
                return;
            }

            // Badge Logic
            const badgeMap = {
                "Performance": { text: "Performance", color: "#E32C2B" },
                "Stance": { text: "Stance", color: "#6c5ce7" },
                "Adventure": { text: "Adventure", color: "#00b894" },
                "Urban": { text: "Urban", color: "#2d3436" },
                "Carbon": { text: "Carbon Fiber", color: "#111111" }
            };
            const badge = badgeMap[style];

            // SUV Specific Info
            const isSUV = type === 'suv';
            const loadRatingBadge = isSUV ? '<div class="spec-badge">Charge Certifiée</div>' : '';
            const tpmsBadge = isSUV ? '<div class="spec-badge">Compatible TPMS</div>' : '';

            wheels.forEach(wheel => {
                const card = document.createElement('div');
                card.className = 'wheel-card';

                const hasPackage = wheel.price > 200; // Fake logic for badge

                // Determine style badge override if wheel has specific style
                let displayBadge = badge;
                if (wheel.style && badgeMap[wheel.style]) {
                    displayBadge = badgeMap[wheel.style];
                }

                card.innerHTML = `
          <div class="wheel-image">
            <svg width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#ccc" stroke-width="1">
              <circle cx="12" cy="12" r="10"/>
              <circle cx="12" cy="12" r="3"/>
              <path d="M12 2v7M12 15v7M2 12h7M15 12h7M4.9 4.9l5 5M14.1 14.1l5 5M4.9 19.1l5-5M14.1 9.9l5-5"/>
            </svg>
            ${displayBadge ? `<div class="style-badge" style="background:${displayBadge.color}">${displayBadge.text}</div>` : ''}
          </div>
          <div class="wheel-details">
            <div class="wheel-size">${wheel.size} - ${wheel.name}</div>
            <div class="wheel-specs">
              <span>${wheel.weight} kg</span>
              ${pcd ? `<span>${pcd}</span>` : ''}
            </div>
            ${isSUV ? `<div class="suv-specs">${loadRatingBadge} ${tpmsBadge}</div>` : ''}
            <div class="wheel-price">À partir de €${wheel.price}</div>
            ${hasPackage ? '<div class="wheel-badge">Montage & équilibrage inclus</div>' : ''}
          </div>
          <div class="wheel-action">
            <button class="btn-add" aria-label="Ajouter au panier">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M12 5v14M5 12h14"/>
              </svg>
            </button>
          </div>
        `;

                // Add click event
                card.querySelector('.btn-add').onclick = () => this.addToCart(wheel);

                container.appendChild(card);
            });
        }, 600);
    }

    addToCart(wheel) {
        // Tracking GA4
        if (typeof gtag !== 'undefined') {
            gtag('event', 'jante_size_selected', {
                brand: this.selection.brand,
                model: this.selection.model,
                year: this.selection.year,
                diameter: wheel.size.split('x')[0],
                width: wheel.size.split('x')[1],
                price: wheel.price
            });
        }

        // Add to cart logic (simulated for now, would be AJAX to Shopify)
        fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                items: [{
                    id: 456789123, // Placeholder ID - needs real product ID
                    quantity: 1,
                    properties: {
                        'Vehicle': `${this.selection.brand} ${this.selection.model} ${this.selection.year}`,
                        'Size': wheel.size,
                        'PCD': vehicleData[this.selection.brand][this.selection.model].pcd
                    }
                }]
            })
        })
            .then(() => {
                this.close();
                window.location.href = '/cart';
            })
            .catch(err => {
                console.log('Simulation: Added to cart logic triggered');
                this.close();
                window.location.href = '/cart'; // Redirect anyway for demo
            });
    }
}

// Initialize
document.addEventListener('DOMContentLoaded', () => {
    new VehicleSelector();
});
